<template>
        <v-container fluid class="py-0">
          <!--
          <v-row >

            <v-col cols=1 class="text-center"  >
              <v-btn 
                ref="add" 
                x-small 
                class="my-auto mx-0"	
                fab 
                color="primary"	
                @click="addItems()"
                :disabled="!AddItems"
              >
                <v-icon dense>fa fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          -->
          <v-row class="px-0">
            <v-col cols=12 >
              <v-data-table
                dense
                :headers="headers"
                :items="Items"
                class="elevation-2"
                min-height="200px"
                height="300px"
                :fixed-header="true"

                hide-default-footer

                :loading="loadGrid"
              
                :mobile-breakpoint=100

                :items-per-page="999"
              >
                <template v-slot:top>
                  <v-toolbar flat dense color="white">
                    <v-spacer></v-spacer>
                    <v-btn color="primary"  class="mb-2 caption " @click="open()">Nueva Imagen</v-btn>
                    <v-dialog v-model="dialog" max-width="480px"  persistent>
                      <v-card >
                        <v-toolbar dense flat dark color="primary  primary--text text--lighten-5 " class="mb-2">
                          <v-toolbar-title class="body-2">Nueva Imagen</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                          <v-btn x-small icon @click="dialog=!dialog">
                            <v-icon class="primary--text text--lighten-5">fa fa-close</v-icon>
                          </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text style="height:220px">
                          <v-container>
                            <v-row>
                            <v-col cols=12>
                              <v-file-input 
                                dense
                                show-size 
                                v-model="file"
                                label="Archivo" 
                                accept="image/*"
                                :rules="rulesFiles"
                                :loading="uploading"
                                @change="viewImage"
                                prepend-icon=""
                                append-icon="$file"

                              >
                              </v-file-input>
                            </v-col>
                            <v-col cols=12>
                              <!--<v-img :src="file.p" aspect-ratio="1.7"></v-img>-->
                              <v-img v-if="previewImage!=null" :src="previewImage" height="125" contain />
                            </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" text @click="close">Cancelar</v-btn>
                          <v-btn color="primary darken-1" text @click="uploadImage(undefined)" :loading="uploading" :disabled="!file">Subir</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item="{item,isSelected,select,headers} ">
                  <tr>
                    <template v-for="(h, idx) in headers" >
                      <td v-if="h.value=='image'" :align="h.align" :key="idx" :class="['caption', h.class]" >
                        <v-avatar tile size="120">
                          <v-img :src="item[h.value]" contain></v-img>
                        </v-avatar>
                      </td>
                      <td v-else-if="h.value=='actions'" :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                        <v-icon
                          small
                          class="mx-3"
                          @click="removeItem(item)"
                        >
                          fa fa-trash-o
                        </v-icon>
                      </td>
                      <td v-else :align="h.align" :key="idx" :class="['body-1', h.class]" v-text="item[h.value]" />
                    </template> 
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Imagenes',
    props:['items','codigo'],

    components: {
      
    },

    data: () => ({
      dialog:false,

      uploading:false,

      loadGrid:false,
      previewImage:null,

      headers: [
        { text: 'Imagen',align: 'start' ,sortable: false, value: 'image' },
        { text: 'Nombre',align: 'start' ,sortable: false, value: 'fileName' },
        { text: ''      ,align: 'center',sortable: false, value: 'actions', width:"85px" },
      ],

      file:undefined,

      rulesFiles: [
        value => {
          if (!value) return 'Debe selecionar un archivo'
          else  if(value.size > 1500000) return 'El archivo debe ser más pequeño, máximo 1.5 MB!'
          return true
          },
      ],
    }),
    created: function () {
      console.log("Componente creado")

      //console.log(this.categoriaID)
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    watch: {

      dialog : function (val){
        if (val) {    
//
          window.addEventListener('paste', this.loadImage)
//
        } else {
          window.removeEventListener('paste', this.loadImage)
        }
      }
    },

    methods: {
      open (){
        this.file = undefined
        this.previewImage = null


        this.dialog = true
      },
      close (){
        this.dialog=false
      },

      async loadImage (e){
        //console.log(this.$refs.file.$refs.input.files)
        //this.$refs.file.$refs.files
        //this.$refs.file.$refs.input.files=e.clipboardData.files
        //this.uploadImage()

        //this.file=
        var items = e.clipboardData.items
        if (!items) return

        for (var i = 0; i < items.length; i++) {

          if (items[i].type.indexOf("image") !== -1) {
            //image
            var blob = items[i].getAsFile();

            let ext = items[i].type.split('/')

            this.file = blob

           // console.log(this.file.name)

            let name=`${this.codigo}_${this.items.length+1}.${ext[1]}`

            let fileReader = new FileReader()

            fileReader.onload =   ev => {
              try {
                console.log("Leer imagen")
                this.previewImage=ev.target.result

                this.uploadImage(name)
              } catch (e) {
                console.log("No se pudo leer la imagen")
              }
            }
            fileReader.readAsDataURL(blob)            
          }
        }

        
        //console.log(e.clipboardData.files)
        //this.$refs.file.$refs.input.files=e.clipboardData.files

      },

      viewImage () {
        console.log("viewImage")
        if (this.file) {
          let fileReader = new FileReader()
          fileReader.onload =   ev => {
            try {
              this.previewImage=ev.target.result
            } catch (e) {
              alert("No se pudo leer el archivo!");
              this.previewImage=null
            }
          }
          fileReader.readAsDataURL(this.file)

        }
        else {
          this.previewImage=null
        }
      },

      async uploadImage(name) {

        console.log("UPLOAD")
        this.uploading=true

        let formData = new FormData()
        formData.append('file',this.file)

        let opt={
            method: 'POST', 
            mode: 'cors',
            body: formData,

        }
        
        let  response = await fetch(`${this.ROOT_API}cms/files/upload`, opt);
        if (response.ok) {
          let r=await response.json()
          
          let image={
            id:0,
            fileName:name || r.originalname,
            imageID:r.filename,
            image:this.previewImage,
            accion:"I"
          }
          //console.log("resultado --> ",image)

          this.items.push(image)
          this.close()

        }
        else {
          console.log("error")
          
        }
        this.uploading=false
      },

      removeItem (item) {
        if (confirm('Seguro que desea eliminar el item seleccionado?')){
          let index = this.items.indexOf(item)
          if (item.id!=0){
            console.log("DELETE LOGICO")
            item.accion="D"
            //this.editedIndex = this.items.indexOf(item)
            this.items[index]=Object.assign({}, item)
          }
          else {
            console.log("DELETE")
            this.items.splice(index,1)
          }
        }
      },


     ///metodos viejos

      async loadMultiple() {
                    let response
            let opt={
                method: 'GET', 
                mode: 'cors'
            }

            response = await fetch(`${this.ROOT_API}titulos_items/?_filters={"tituloID":${this.frm.titulo.value}}`, opt);
            if (response.ok){
              let r=await response.json()
              console.log("r-->",r)
              this.itemsTitulos=r.map(item => {
                return {
                  value:item.id,
                  text:item.descripcion 
                }
              })
            }
      },


      async initialize () {

      },

    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),
      Items () {
        let r
        //console.log("ITEMS",this.items)
        r=this.items.filter( item => item.accion!="D")
        return r
      },
    },
  }
</script>

<style scoped>

</style>
